import { useEffect } from "react";
import { notification } from "antd";
import { NOTIFICATION_MESSAGES } from "@/shared/utils";
import { isForbiddenError } from "../utils/get-http-error-status";

const VERSIONS_ACCESS_DENIED_MESSAGE =
  NOTIFICATION_MESSAGES.VERSIONS_ACCESS_DENIED_DESC; // "У вас нет прав на просмотр списка версий"

const notifiedItemIds = new Set<string>();

export const useNotifyVersionsForbidden = (
  error: unknown,
  isError: boolean,
  itemNoVersionId?: string,
  enabled = true,
) => {
  const isForbidden = enabled && isError && isForbiddenError(error);

  useEffect(() => {
    if (!isForbidden || !itemNoVersionId) {
      return;
    }

    if (notifiedItemIds.has(itemNoVersionId)) {
      return;
    }

    notifiedItemIds.add(itemNoVersionId);
    notification.warning({
      message: NOTIFICATION_MESSAGES.VERSIONS_ACCESS_DENIED, // "Нет доступа"
      description: VERSIONS_ACCESS_DENIED_MESSAGE,
    });
  }, [isForbidden, itemNoVersionId]);
};

export { VERSIONS_ACCESS_DENIED_MESSAGE };
